import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-discount-modal',
  templateUrl: './discount-modal.component.html',
  styleUrls: ['./discount-modal.component.css']
})
export class DiscountModalComponent {
  @Output() close = new EventEmitter<void>();
  constructor(private clipboard: Clipboard, private toastr: ToastrService) { }

  copyToClipboard(code: string) {
    this.clipboard.copy(code);
    this.toastr.success(`${code} copied to clipboard`, 'Success');
  }
} 